
import React from 'react';
import { useBreakpoint } from '@/hooks/use-mobile';
import { cn } from '@/lib/utils';

interface DecorationProps {
  position: string;
  size: string;
  color: string;
  opacity?: string;
  blur?: string;
}

const Decoration: React.FC<DecorationProps> = ({ 
  position, 
  size, 
  color, 
  opacity = "opacity-5", 
  blur = "blur-3xl" 
}) => (
  <div 
    className={cn(
      'absolute rounded-full',
      position,
      size,
      color,
      opacity,
      blur
    )}
  />
);

const HeroDecorations = () => {
  const { isMobile } = useBreakpoint();
  
  return (
    <>
      {/* Top right decoration */}
      <Decoration 
        position={isMobile ? 'top-12 right-5' : 'top-20 right-10'}
        size={isMobile ? 'w-40 h-40' : 'w-64 h-64'}
        color="bg-brand-blue"
      />
      
      {/* Bottom left decoration */}
      <Decoration 
        position={isMobile ? 'bottom-8 left-5' : 'bottom-10 left-10'}
        size={isMobile ? 'w-48 h-48' : 'w-72 h-72'}
        color="bg-purple-400"
      />
      
      {/* Mobile-only decoration */}
      {isMobile && (
        <Decoration 
          position="-top-10 -left-10"
          size="w-40 h-40"
          color="bg-brand-accent"
        />
      )}
    </>
  );
};

export default HeroDecorations;
